import { motion } from "framer-motion";
import { ASSETS } from "../lib/site";

const AnimatedLogo = ({ className = "h-9 w-9", delay = 0.2, onView = false, testId }) => {
  const reveal = onView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, margin: "-40px" } }
    : { initial: "hidden", animate: "show" };

  return (
    <motion.span
      className="inline-flex items-center justify-center"
      data-testid={testId}
      variants={{
        hidden: { clipPath: "inset(0 100% 0 0)", opacity: 0.4 },
        show: {
          clipPath: "inset(0 0% 0 0)",
          opacity: 1,
          transition: { duration: 1.0, delay, ease: [0.16, 1, 0.3, 1] },
        },
      }}
      {...reveal}
    >
      <img src={ASSETS.shortLogo} alt="Artwork360 AV360 mark" className={`${className} block object-contain`} />
    </motion.span>
  );
};

export default AnimatedLogo;
